import React from "react";
import PropTypes from "prop-types";
import DangerousHtml from "../DangerousHtml";

function Linkify({ text, conf, isHtml, isHtmlDirty }) {
  // Break string in "-" separator so we can replace values easily.
  // In order to avoid breaking the string in every -
  // we encode the & to &amp; and then use "&-" as separator which should be an impossible value in the original text.
  const separator = "-";
  const ampIn = "&";
  const ampOut = "&amp;";
  const sepIn = separator;
  const sepOut = `&${separator}`;
  const ampInReg = new RegExp(`/${ampIn}/`, "g");
  const sepInReg = new RegExp(`/${sepIn}/`, "g");
  const sepReg = new RegExp(`/${sepOut}`, "g");
  const ampReg = new RegExp(`/${ampOut}`, "g");

  function removeSeparator(txt) {
    return txt.replace(ampInReg, ampOut).replace(sepInReg, sepOut);
  }

  function reinstateSeparator(txt) {
    return txt.replace(sepReg, sepIn).replace(ampReg, ampIn);
  }

  const cleanTxt = removeSeparator(text);

  const items = conf
    .reduce((a, i) => a.replace(i.regexMatch, `${sepOut}$&${sepOut}`), cleanTxt)
    .split(sepOut);

  return (
    <>
      {items.map((t, i) => {
        const txt = reinstateSeparator(t);
        const key = `${i}-${new Date()}`;
        for (let x = 0; x < conf.length; x++) {
          const { regexMatch, Renderer } = conf[x];
          if (t.match(regexMatch)) {
            return <Renderer key={key} match={t} />;
          }
        }
        return isHtml ? (
          <DangerousHtml
            className="tw-inline"
            key={key}
            str={txt}
            isDirty={isHtmlDirty}
          />
        ) : (
          <span key={key}>{txt}</span>
        );
      })}
    </>
  );
}

Linkify.propTypes = {
  text: PropTypes.string,
  isHtml: PropTypes.bool,
  conf: PropTypes.arrayOf(
    PropTypes.shape({
      regexMatch: PropTypes.instanceOf(RegExp),
      Renderer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    })
  ),

  isHtmlDirty: PropTypes.bool,
};

Linkify.defaultProps = {
  text: "",
  conf: [],
  isHtml: false,
  isHtmlDirty: true,
};

export default React.memo(Linkify);
